{
  "localSettings": {
    "ancillaries": {
      "productCard": {
        "originalPriceLabel": "Alkuperäinen hinta"
      }
    }
  },
  "ancillaries": {
    "perBooking": "/ varaus",
    "bundle": {
      "conflictingBundle": "",
      "serviceIncludedInBundleNotification": "",
      "upsellCard": {
        "seatWifi": {
          "buttonText": {
            "addCombo": "Add combo",
            "added": "Added"
          },
          "addCombo": {
            "productCardTitle": "Seat + {productName}",
            "title": "10% off when booked together",
            "image": {
              "alt": "",
              "contentId": 3560630,
              "data": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg",
              "teaserTitle": "",
              "responsiveImageLinksData": {
                "landscape_ratio21x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=1714&x=0&y=791"
                },
                "landscape_ratio16x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=2250&x=0&y=278"
                },
                "portrait_ratio1x1": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=2666&height=2666&x=681&y=0"
                },
                "landscape_ratio4x3": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=3555&height=2666&x=445&y=0"
                }
              }
            }
          },
          "addProduct": {
            "title": "Get internet for less withn a seat",
            "image": {
              "alt": "",
              "contentId": 3560630,
              "data": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg",
              "teaserTitle": "",
              "responsiveImageLinksData": {
                "landscape_ratio21x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=1714&x=0&y=791"
                },
                "landscape_ratio16x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=2250&x=0&y=278"
                },
                "portrait_ratio1x1": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=2666&height=2666&x=681&y=0"
                },
                "landscape_ratio4x3": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=3555&height=2666&x=445&y=0"
                }
              }
            }
          }
        }
      },
      "toggle": {
        "personalized": {
          "comboOfferText": "Personoitu kombo"
        }
      },
      "bundlePriceLabel": "Paketin hinta",
      "discountLabel": "{percentage}% alennus",
      "serviceCard": {
        "inCartTag": "Ostoskorissa",
        "tierBenefitTag": "Jäsenetu"
      }
    },
    "lounge": {
      "detailsLinkTitle": "Loungen tiedot"
    },
    "quota": {
      "onlyQuotaLeft": {
        "singular": "Vain yksi jäljellä",
        "plural": "{quota} jäljellä"
      },
      "quotaLeft": {
        "singular": "1 jäljellä",
        "plural": "{quota} jäljellä"
      },
      "noQuotaLeft": "0 jäljellä"
    },
    "meals": {
      "quota": {
        "enoughForAll": {
          "title": {
            "singular": "Yksi ateria jäljellä",
            "plural": "{amount} ateriaa jäljellä"
          },
          "description": "Valitse ateriasi ennen kuin ne loppuvat."
        },
        "allSelected": {
          "title": "Ei yhtään ateriaa jäljellä",
          "description": "Olet lisännyt aterian kaikille varauksessasi."
        },
        "shortForGroup": {
          "title": {
            "singular": "Vain yksi ateria jäljellä {passengerCount} hengen ryhmällesi",
            "plural": "Vain {amount} ateriaa jäljellä {passengerCount} hengen ryhmällesi"
          },
          "description": "Aterioita on saatavilla rajattu määrä määrä lentokoneen tilan vuoksi.",
          "noneLeft": "Ei yhtään ateriaa jäljellä."
        },
        "takenByOtherPassenger": "Lisäsit viimeisen jäljellä olleen aterian toiselle matkustajalle."
      }
    },
    "priority": {
      "quota": {
        "enoughForAll": {
          "title": {
            "singular": "Vain yksi priority-palvelu jäljellä",
            "plural": "Vain {amount} priority-palvelua jäljellä"
          },
          "description": "Kannattaa varmistaa joutuisampi matka nyt."
        },
        "allSelected": {
          "title": "Ei yhtään priority-palvelua jäljellä",
          "description": "Olet lisännyt palvelun kaikille varauksessasi."
        },
        "shortForGroup": {
          "title": {
            "singular": "Vain yksi priority-palvelu jäljellä {passengerCount} hengen ryhmällesi",
            "plural": "Vain {amount} priority-palvelua jäljellä {passengerCount} hengen ryhmällesi"
          },
          "description": "Palvelun saatavuus on rajattu, jotta piority-jonot pysyvät lyhyenä.",
          "noneLeft": "Ei yhtään priority-palvelua jäljellä."
        },
        "takenByOtherPassenger": "Lisäsit viimeisen priority-palvelun toiselle matkustajalle."
      }
    },
    "sport": {
      "quota": {
        "exhausted": {
          "default": "Tila tuotteelle loppu tältä lennolta.",
          "BIKE": "Kaikki tila polkupyörille loppu tältä lennolta.",
          "GOLF": "Kaikki tila golfvarusteille loppu tältä lennolta.",
          "SKIS": "Kaikki tila hiihtovarusteille loppu tältä lennolta.",
          "SURF": "Kaikki tila lainelaudaudoille loppu tältä lennolta."
        },
        "takenByOtherPassenger": {
          "default": "Valitsit viimeisen tuotteen toiselle matkustajalle.",
          "BIKE": "Valitsit viimeisen polkupyörän toiselle matkustajalle.",
          "GOLF": "Valitsit viimeiset golfvarusteet toiselle matkustajalle.",
          "SKIS": "Valitsit viimeiset hiihtovarusteet toiselle matkustajalle.",
          "SURF": "Valitsit viimeisen lainelaudan toiselle matkustajalle."
        }
      }
    },
    "ancillaryCombos": {
      "eligibility": {
        "boundFlown": "Tämä lento on jo lähtenyt.",
        "notAvailableBus": "Valitettavasti <b>matkasi tälle osuudelle ei voi ostaa komboa</b>, koska tämä on bussiyhteys.",
        "notAvailableTrain": "Valitettavasti <b>matkasi tälle osuudelle ei voi ostaa komboa</b>, koska tämä on junayhteys."
      },
      "noAncillaryCombosAvailable": "Komboja ei ole saatavilla matkasi tälle osuudelle.",
      "noAncillaryCombosAvailableBus": "Valitettavasti <b>matkasi tälle osuudelle ei voi ostaa komboa</b>, koska tämä on bussiyhteys.",
      "noAncillaryCombosAvailableForOperatingAirline": "Komboja ei ole saatavilla tälle lennolle"
    }
  },
  "paxDetails": {
    "reviewTitle": {
      "single": "Review passenger details",
      "multi": "Review and add details"
    }
  },
  "purchase": {
    "success": {
      "stayInTouch": {
        "default": {
          "title": "Lähetämme sinulle viestejä matkalle valmistautumisesta",
          "description": "<p>Saat muistutuksia, vinkkejä ja tarjouksia liittyen tuleviin matkoihisi sähköpostilla.</p><p>Voit muokata viestintäasetuksiasi milloin tahansa <a href='https://www.finnair.com/fi-fi/my-finnair-plus/update-profile?section=marketing-preferences' target='_blank' rel='noopener noreferrer'>Finnair Plus -profiilissasi</a>.</p>"
        },
        "multiPassenger": {
          "title": "Lähetämme sinulle viestejä matkalle valmistautumisesta",
          "description": "<p>Saat muistutuksia, vinkkejä ja tarjouksia liittyen tuleviin matkoihisi sähköpostilla. Myös muut varauksen matkustajat saattavat saada viestejä heidän viestintäasetustensa mukaisesti.</p><p>Voit muokata asetuksiasi milloin tahansa <a href='https://www.finnair.com/fi-fi/my-finnair-plus/update-profile?section=marketing-preferences' target='_blank' rel='noopener noreferrer'>Finnair Plus -profiilissasi</a>.</p>"
        },
        "emailMismatch": {
          "title": "Lähetämme sinulle viestejä matkalle valmistautumisesta",
          "description": "<p>Saat muistutuksia, vinkkejä ja tarjouksia liittyen tuleviin matkoihisi varauksessa käyttämääsi sähköpostiosoitteeseen: {email}</p><p>Voit muokata viestintäasetuksiasi sähköpostin alaosassa olevasta linkistä.</p>"
        },
        "multiPassengerEmailMismatch": {
          "title": "Lähetämme sinulle viestejä matkalle valmistautumisesta",
          "description": "<p>Saat muistutuksia, vinkkejä ja tarjouksia liittyen tuleviin matkoihisi varauksessa käyttämääsi sähköpostiosoitteeseen: {email}. Myös muut varauksen matkustajat saattavat saada viestejä heidän viestintäasetustensa mukaisesti.</p><p>Voit muokata viestintäasetuksiasi sähköpostin alaosassa olevasta linkistä.</p>"
        }
      }
    }
  }
}
